import { configuration } from 'src/configuration';

const { cognitoUrl, appUrl, cognitoClientId } = configuration;

export const authenticateUser = async (code: string) => {
  console.log('Authenticating user with code:', code);
  const response = await fetch(`${cognitoUrl}/oauth2/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: cognitoClientId,
      redirect_uri: `${appUrl}/callback`,
      code,
    }),
  });

  console.log('Response status:', response.status);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  const data = await response.json();

  return data;
};

export const refreshUser = async (token: string, clientId: string) => {
  const response = await fetch(`${cognitoUrl}/oauth2/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: clientId,
      redirect_uri: `${appUrl}/callback`,
      refresh_token: token,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  const data = await response.json();

  return data;
};

export const redirectSignIn = async ({
  providerName,
  clientId,
}: {
  providerName: string;
  clientId?: string;
}) => {
  const searchParams = new URLSearchParams({
    response_type: 'code',
    client_id: clientId || cognitoClientId,
    redirect_uri: `${appUrl}/callback`,
    identity_provider: providerName,
  });
  const redirectUrl = `${cognitoUrl}/oauth2/authorize?` + searchParams.toString();
  window.location.replace(redirectUrl);
};
